// durationService.js
import { database, ref, get } from "../../FirebaseConfig";

/**
 * Fetches subscription durations configuration from Firebase
 * @returns {Promise<Object>} Subscription durations data
 */
export const getSubscriptionDurations = async () => {
  try {
    // Reference to the subscription durations in Firebase
    const durationRef = ref(database, 'config/subscription_durations');
    
    // Fetch the data
    const snapshot = await get(durationRef);
    
    if (snapshot.exists()) {
      // Return the durations data
      return snapshot.val();
    } else {
      console.warn("No subscription durations found in database");
      return null;
    }
  } catch (error) {
    console.error("Error fetching subscription durations:", error);
    throw error;
  }
};

/**
 * Formats duration objects into an array suitable for UI display
 * @param {Object} durationsData Raw durations data from Firebase
 * @returns {Array} Formatted array of duration options
 */
export const formatDurationsForUI = (durationsData) => {
  if (!durationsData) return [];
  
  return Object.entries(durationsData)
    .filter(([_, data]) => data.active) // Only include active durations
    .map(([key, data]) => ({
      id: key,
      value: key,
      label: data.display_name,
      description: data.description,
      minutes: data.minutes,
      discount: data.discount || 0,
      priceTier: data.price_tier
    }))
    .sort((a, b) => a.minutes - b.minutes); // Sort by duration length
};